var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.89,
    height: 47.523,
    viewBox: "0 0 67.89 47.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-168 -67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1714",
    "data-name": "Rectangle 1714",
    d: "M22.63,0H45.26a0,0,0,0,1,0,0V22.63A22.63,22.63,0,0,1,22.63,45.26h0A22.63,22.63,0,0,1,0,22.63v0A22.63,22.63,0,0,1,22.63,0Z",
    transform: "translate(213.26 112.26) rotate(180)",
    fill: "#ecebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1712",
    "data-name": "Rectangle 1712",
    d: "M22.63,0H45.26a0,0,0,0,1,0,0V22.63A22.63,22.63,0,0,1,22.63,45.26h0A22.63,22.63,0,0,1,0,22.63v0A22.63,22.63,0,0,1,22.63,0Z",
    transform: "translate(190.63 69.263)",
    fill: "#dc2342"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0a6b6e69a6c2628ea58a1ef3dc34ec37.svg";
export { ForwardRef as ReactComponent };